import axios from 'axios';

// База API: в проде (за Nginx) — относительный '/api', локально без Docker — localhost:8000.
// Переопределяется переменной REACT_APP_API_URL на этапе сборки.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

export const API_BASE = api.defaults.baseURL;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
